import { TRecurrenceOption } from '../../types'

export const recurrenceOptions: TRecurrenceOption[] = [
  'stopAfter',
  'stopOnDate',
  'never',
]
